/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Scope_Detail5Inputs */

const en_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which chats the bot owns, and where a human takes over.`)
};

const ar_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أي المحادثات يتولاها البوت وأين يستلم الإنسان.`)
};

const bn_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বট কোন চ্যাট সামলাবে আর মানুষ কোথায় নেবে।`)
};

const de_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Chats der Bot übernimmt und wo ein Mensch einspringt.`)
};

const es_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué chats gestiona el bot y dónde toma el relevo un humano.`)
};

const fr_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels chats le bot gère et où un humain prend le relais.`)
};

const pt_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que chats o bot trata e onde um humano assume.`)
};

const zh_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明确机器人负责哪些对话，以及人工在何处接管。`)
};

const tr_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Botun hangi sohbetleri üstleneceği ve insanın nerede devralacağı.`)
};

const ru_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какие чаты ведёт бот и где перехватывает человек.`)
};

const pl_svc_messaging_bots_scope_detail5 = /** @type {(inputs: Svc_Messaging_Bots_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Które czaty prowadzi bot, a gdzie przejmuje człowiek.`)
};

/**
* | output |
* | --- |
* | "Which chats the bot owns, and where a human takes over." |
*
* @param {Svc_Messaging_Bots_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_scope_detail5 = /** @type {((inputs?: Svc_Messaging_Bots_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "de") return de_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "es") return es_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_scope_detail5(inputs)
	return en_svc_messaging_bots_scope_detail5(inputs)
});
export { svc_messaging_bots_scope_detail5 as "svc_messaging-bots_SCOPE_detail" }